import React, { useCallback, useState } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import styles from './userReferralsShowPageStyles';

const ReferralMethodologyModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        className={styles.modalLink}
        onClick={() => setIsModalOpen(true)}
        text="How It Works"
        type={BUTTON_TYPES.LINK}
      />
    ),
    []
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      size="lg"
      title="How Referrals Work"
    >
      <div>
        <p>
          Refer qualified friends and colleagues to SumZero, and you'll both be rewarded with free
          access. Here's how it works:
        </p>
        <ul>
          <li>
            <strong>
              When someone you refer is accepted to and registers for SumZero you both get two weeks
              of free access
            </strong>
            . SumZero is a selective community only for buyside professionals or those with
            significant buyside experience. Only those with the right background will be accepted.
            If someone you refer is accepted, you'll both get free access once your referral
            completes the simple registration process. There's no limit to the number of people you
            can refer; if you refer 50 qualified applicants that get accepted, you'll get 100 weeks
            of free access.
          </li>
          <li>
            <strong>
              When someone you referred posts their first idea, you'll get 2 months of free access
              and your referral will get 6 months of free access
            </strong>
            . We only accept ideas that meet our
            <a href="https://sumzero.com/pro/quality-guidelines">quality guidlines.</a> Once your
            referral posts an idea that we accept, you'll both be rewarded with access.
          </li>
          <li>
            <strong>
              When someone you referred posts their second idea, you'll get 2 more months of free
              access and your referral will get 6 more months
            </strong>
            . After the second idea, no free additional free access will be awarded for this
            referral.
          </li>
          <li>
            <strong>
              To get rewarded, your referrals must apply to SumZero via your unique referral link
            </strong>
            . Unfortunately, we won't be able to attribute a referral to you unless signup is done
            through your referral link. When you use the "Invite New Members" button, your referral
            link will be included in the emails sent to your referrals.
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default ReferralMethodologyModal;
